import React, {Component, Fragment} from 'react';
import TimeTable from '../Components/TimeTable';
import './TimeTablePage.scss'
import {Link} from "react-router-dom";
import Button from "../Components/Button";
import {thinkHard, goWild} from "../Components/TimeTable/SpeakerList";
import ModalPortal from "../ModalPortal";
import Modal from "../Components/Modal";

class TimeTablePage extends Component {
    state = {
        modal: false,
        index: null
    };
    handleOpenModal = (e) => {
        const index = e.target.getAttribute("data-index");
        this.setState({
            modal: true,
            index: parseInt(index),
            isThinkHard: !!e.target.getAttribute("data-is-th")
        });
    };
    handleCloseModal = () => {
        this.setState({
            modal: false
        });
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.index !== nextState.index
            || this.state.modal !== nextState.modal
    }

    render() {
        return (
            <div className="wtm-timeTable">
                <h1 className="title">시간표</h1>
                <p>*발표 자료는 순차적으로 업데이트 될 에정입니다.</p>

                <Fragment className="web-content">
                    <TimeTable/>
                </Fragment>

                <div className="mobile-content">
                    <div className="container">
                        <div className="common">
                            <ul className="schedule">
                                <li className="schedule-item">
                                    <h3>
                                        <span className="label">체크인</span>
                                        <span className="time">11:00 ~ 12:00</span>
                                    </h3>
                                </li>
                                <li className="schedule-item">
                                    <h3>
                                        <span className="label">키노트</span>
                                        <span className="time">12:00 ~ 12:20</span>
                                    </h3>
                                </li>
                            </ul>
                        </div>
                        <ul className="think-hard">
                            <li className="session-item room-name item-20 after-break">
                                <h1>THINK HARD</h1>
                                <h3>Track 1, 401</h3>
                            </li>
                            {thinkHard.map((speaker, index) => {
                                let className = "session-item ";
                                className += `item-${speaker.time} `;
                                className += speaker.afterBreak ? 'after-break ' : null;

                                if (speaker.isOpen) {
                                    return (
                                        <li key={`th-open-${index}`} className={className}>
                                            {/*<p className="time">{speaker.fullTime}</p>*/}
                                            <h3>
                                                {speaker.event.title}
                                            </h3>
                                            <h5>{speaker.profile.name}</h5>
                                            <p className="btn-container">
                                                {speaker.event.materialLink &&
                                                <a href={speaker.event.materialLink} target="_blank"
                                                   className="btn-ppt-link">발표 자료</a>
                                                }
                                                <button className="btn-open-modal" data-index={index}
                                                        onClick={this.handleOpenModal}> 더 알아보기
                                                </button>
                                            </p>
                                        </li>
                                    )
                                } else {
                                    className += "not-now";
                                    return (
                                        <li key={`th-notnow-${index}`} data-index={index} data-is-th={true}
                                            className={className}>
                                            <p data-index={index} data-is-th={true}
                                               className="time">{speaker.fullTime}</p>
                                            <h3 data-index={index} data-is-th={true}>
                                                {speaker.event.title}
                                            </h3>
                                        </li>
                                    )
                                }

                            })}
                        </ul>
                        <ul className="go-wild">
                            <li className="session-item room-name item-20 after-break">
                                <h1>GO WILD</h1>
                                <h3>Track 2, 402</h3>
                            </li>
                            {goWild.map((speaker, index) => {
                                let className = "session-item ";
                                className += `item-${speaker.time} `;
                                className += speaker.afterBreak ? 'after-break ' : null;

                                if (speaker.isOpen) {
                                    return (
                                        <li key={`gw-open-${index}`} className={className}
                                        >
                                            {/*<p className="time">{speaker.fullTime}</p>*/}
                                            <h3>
                                                {speaker.event.title}
                                            </h3>
                                            <h5>{speaker.profile.name}</h5>
                                            <p className="btn-container">
                                                {speaker.event.materialLink &&
                                                <a href={speaker.event.materialLink} target="_blank"
                                                   className="btn-ppt-link">발표 자료</a>
                                                }
                                                <button className="btn-open-modal" data-index={index}
                                                        onClick={this.handleOpenModal}> 더 알아보기
                                                </button>
                                            </p>
                                        </li>
                                    )
                                } else {
                                    return (
                                        <li key={`gw-open-${index}`} data-index={index} className={className}>
                                            <p data-index={index} className="time">{speaker.fullTime}</p>
                                            <h3 data-index={index}>
                                                {speaker.event.title}
                                            </h3>
                                        </li>
                                    )
                                }

                            })}
                        </ul>
                    </div>
                </div>


                <Link to="/">
                    <Button btnText="홈화면으로 돌아가기"
                            extraClassName="btn-main-event btn-lg btn-green"
                            absoluteUrl=""/>
                </Link>

                {this.state.modal && (
                    <ModalPortal>
                        <Modal onClose={this.handleCloseModal}
                               data={this.state.isThinkHard ? thinkHard[this.state.index] : goWild[this.state.index]}/>
                    </ModalPortal>
                )}
            </div>
        );
    }
}

export default TimeTablePage;
